// TODO: creator-camp-cleanup
import { Button, PromotionalBanner } from '@buffer-mono/popcorn'
import creatorCampIntroIllustration from './creatorCampIntroIllustration.svg'
import { BufferTrackerReact as BufferTracker } from '@buffer-mono/tracking-plan'
import { useOrganizationId } from '~publish/contexts/AccountContext'

export const CreatorCampIntroBanner = (): JSX.Element => {
  const organizationId = useOrganizationId()

  return (
    <PromotionalBanner>
      <PromotionalBanner.Content>
        <PromotionalBanner.Heading size="medium">
          Creator Camp is coming soon, starting June 16! 🚀
        </PromotionalBanner.Heading>
        <PromotionalBanner.Description>
          A 30-day challenge to help you build your posting habit — with daily
          templates, prompts, and support from fellow creators.
        </PromotionalBanner.Description>
        <PromotionalBanner.Actions>
          <Button
            as="a"
            href="https://buffersurvey.typeform.com/to/wETeG8QT"
            target="_blank"
            rel="noopener noreferrer"
            size="large"
            onClick={(): void =>
              BufferTracker.cTAClicked({
                cta: 'create-templates-introBanner-joinCreatorCamp-1',
                organizationId: organizationId ?? '',
                product: 'create',
                clientName: 'publishWeb',
                upgradePathName: null,
              })
            }
          >
            Join Creator Camp
          </Button>
          <Button
            as="a"
            href="https://buffer.com/resources/creator-camp-announcement/"
            target="_blank"
            rel="noopener noreferrer"
            variant="tertiary"
            size="large"
            onClick={(): void =>
              BufferTracker.cTAClicked({
                cta: 'create-templates-introBanner-learnMore-1',
                organizationId: organizationId ?? '',
                product: 'create',
                clientName: 'publishWeb',
                upgradePathName: null,
              })
            }
          >
            Learn More
          </Button>
        </PromotionalBanner.Actions>
      </PromotionalBanner.Content>
      <PromotionalBanner.Image
        fallbackColor="#D5DBFF"
        src={creatorCampIntroIllustration}
      />
    </PromotionalBanner>
  )
}
